/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_Empty_FilteredInputs */

const vi_list_empty_filtered = /** @type {(inputs: List_Empty_FilteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có kết quả nào khớp bộ lọc`)
};

/**

* @param {List_Empty_FilteredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const list_empty_filtered = /** @type {((inputs?: List_Empty_FilteredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_Empty_FilteredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_list_empty_filtered(inputs)
});